import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const DashboardPage = lazy(() => import('./DashboardPage'));

// The page itself shows the dashboards the user's permissions allow, or an empty state when there is none.
const routes: RouteObject[] = [{ path: '/dashboard', element: <DashboardPage /> }];
export default routes;
